const Search = ({ color = "#7e858f" }) => (
  <svg
    width="0.95rem"
    height="0.95rem"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.23783 17.5672C13.3913 17.5672 16.7584 14.2001 16.7584 10.0467C16.7584 5.89318 13.3913 2.52612 9.23783 2.52612C5.08435 2.52612 1.71729 5.89318 1.71729 10.0467C1.71729 14.2001 5.08435 17.5672 9.23783 17.5672Z"
      stroke={color}
      strokeWidth="2.53324"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5501 18.3588L15.9668 16.7755"
      stroke={color}
      strokeWidth="2.53324"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Search;
